/* globals dataLayer, adobe */
(function(window, angular, undefined) {
    angular.module('formApp')
        .controller('activateEcoverController', ['$scope', '$rootScope','FormService', 'updateHeader', 'formData', '$state', 'stateService', 'errorHandler', 'LoadingInterceptor', 'sessionService', 'moment', 'dataLayerService', 'dataUtils', '$q', '$window','$timeout', 'scrollToPoint',
            function($scope, $rootScope,formService, updateHeader, formData, $state, stateService, errorHandler, loadingInterceptor, sessionService, moment, dataLayerService, dataUtils, $q, $window, $timeout, scrollToPoint) {
            $scope.tooglePet = false;

            sessionService.start();
            $scope.dobDateMax = moment().subtract(18, 'years').format('YYYY-MM-DD');
            $scope.dobDateMin = moment().subtract(120, 'year').format('YYYY-MM-DD');
            $scope.retrieveQuote = {};

            $scope.formData = formData;

            $scope.$watch('gatewayReady', function (newVal, oldVal) {
                if (newVal === true) {
                    if (sessionStorage.getItem('formStateUri')) {
                        formService.setApplicationId(sessionStorage.getItem('formStateUri'));
                    }
                    
                    loadingInterceptor.incrementRequests();

                    refresh().then(function (response) {
                        loadingInterceptor.decrementRequests();
                        $scope.formData.pets = response.data.application.pets;
                        $scope.formData.aboutYou = response.data.application.aboutYou;
                        $scope.formData.aboutYou.quoteFollowupMarketingOptOut = $scope.formData.aboutYou.quoteFollowupMarketingOptOut || $scope.schema.application.aboutYou.quoteFollowupMarketingOptOut.defaultValue;
                        $scope.formData.cover = response.data.application.cover;

                        $scope.channel = dataUtils.freeCoverChannel(response.data.officeUseOnly.params.prodId);
                        
                        $scope.coverDaysRemaining = moment(response.data.officeUseOnly.params.coverNoteEndDate, 'DD/MM/YYYY').startOf('day').diff(moment().startOf('day'), 'days');

                        $scope.coverNoteEndDate = moment(response.data.officeUseOnly.params.coverNoteEndDate,'DD/MM/YYYY').toDate();
                        $scope.activateBeforeDate = moment(response.data.officeUseOnly.params.coverNoteEndDate,'DD/MM/YYYY').add(1,'day').toDate();

                        $scope.coverStartDateMin = moment().format('YYYY-MM-DD');
                        $scope.coverStartDateMax = $scope.coverDaysRemaining >= 0 ? moment($scope.coverNoteEndDate).add(1,'day').format('YYYY-MM-DD') : moment().add(29, 'days').format('YYYY-MM-DD');
                        $scope.coverDateReady = true ;
                        $scope.isVoucher = response.data.officeUseOnly.params.voucher && response.data.officeUseOnly.params.voucher === 'true';
                     
                        $scope.illnessStartDate = moment(response.data.officeUseOnly.params.parisIllnessStartDate, 'YYYY-MM-DD').toDate();

                        // If MB schema
                        if(!$scope.$parent.$parent.schema.types.dog.details.crossBreed){
                            if(response.data.application.pets[0].type === 'dog' && response.data.application.pets[0].details.crossBreed && !response.data.application.pets[0].details.breedOne || response.data.application.pets[0].type === 'dog' && response.data.application.pets[0].details.weight && !response.data.application.pets[0].details.breedOne){
                                $scope.isMbConversion = true;
                                $scope.formData.pets[0].details.type = 'MultiBreed';
                                $scope.formData.pets[0].details.breedOne = '';
                                $scope.formData.pets[0].details.breedTwo = '';
   
                            }
                            else if (response.data.application.pets[0].type === 'dog' && response.data.application.pets[0].details.crossBreed && response.data.application.pets[0].details.breedOne && response.data.application.pets[0].details.breedTwo || response.data.application.pets[0].type === 'dog' && response.data.application.pets[0].details.weight && response.data.application.pets[0].details.breedOne && response.data.application.pets[0].details.breedTwo){
                               $scope.isMbConversion = true;
                               $scope.isMbConverted = true;
                            }
                            else{
                               $scope.isMbConversion = false;
                               $scope.isMbConverted = false;
                            }
                            if(response.data.application.pets[0].type === 'dog' && response.data.application.pets[0].details.pedigreeBreed){
         
                                $scope.formData.pets[0].details.type = 'SingleBreed';
                                $scope.formData.pets[0].details.breedOne = response.data.application.pets[0].details.pedigreeBreed;
                            }
                        }

                        if(response.data.officeUseOnly && (response.data.officeUseOnly.params.campaign === 'LAPIDALT' || response.data.officeUseOnly.params.campaign === 'IDTALERT' )) {
                            $scope.$parent.idt = 'true';
                        } else {
                            $scope.$parent.idt = 'false';
                        }


                        updateHeader.petType = formData.pets[0].type;              

                        dataLayer.push({
                            'event' : 'dataAvailable',
                            'funnelName': parseInt(dataLayerService.setFunnelName()),
                            'funnelVersion': '1.0', 
                            'funnelPageNumber': 2,
                            'funnelSfc': sessionStorage.getItem('eCoverJourney') === 'recognised' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                            'funnelFc': sessionStorage.getItem('eCoverJourney') === 'retrieveQB',
                            'funnelFcRtn': sessionStorage.getItem('eCoverJourney') === 'return' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                            'environment': window.location.hostname,
                            'bravCode': '',
                            'campaignCode': ''
                        });


                    });
                }
            });

            function refresh() {
                return formService.getApplication();
            }

            $scope.overSixMonths = function (pet) {
                if (pet.details !== undefined && pet.details.dateOfBirth !== undefined) {
                var dob = pet.details.dateOfBirth;
                var diffMonths = moment().diff(moment(dob), 'months', true);
                if (diffMonths > 6) {
                    return true;
                } else {
                    return false;
                }
                }
                };

            $scope.showDeferment = function() {
                return $scope.isVoucher && moment(formData.cover.startDate, 'YYYY-MM-DD').isBefore(moment($scope.illnessStartDate));
            };

            $scope.submit = function() {
                loadingInterceptor.incrementRequests();
                formService.postAboutYou($scope.formData.aboutYou).then(function() {
                    return formService.updatePet($scope.formData.pets[0]);
                }).then(function() {
                    if ($scope.coverDaysRemaining >= 0) {
                        return formService.postCover({startDate: $scope.formData.cover.startDate});
                    } else {
                        var deferred = $q.defer();
                        deferred.resolve();
                        return deferred.promise;
                    }
                }).then(function() {
                    loadingInterceptor.decrementRequests();
                    var step3State = 'quote';
                    var i=0;
                    
                    step3State = 'quote';
                    while (i < $scope.formData.pets.length -1 && $scope.formData.pets[i].chosenCover && $scope.formData.pets[i].chosenCover.productId && $scope.formData.pets[i].chosenCover.productLine) {
                        i++;
                    }
                    // console.log('i = ', i);
                    if(!$scope.formData.pets[i].chosenCover) {
                        step3State = 'quote';
                    } else {
                        step3State = 'quote';
                    } 
                    $state.go('quote-ec-select', {id: i, selectState: step3State, forward: true  });
                    
                }).catch(function(error) {
                    errorHandler.reportErrors(error,'redirect','tech');
                });               
            };

            $scope.tooglePettName = function(){
                $scope.tooglePet = ! $scope.tooglePet;
                if( $scope.tooglePet){
                    $timeout(function () {
                        document.activeElement.blur();
                        var elm = document.getElementById('newPetName');
                        elm.click();
                        elm.focus();
                    });
                }
            };

            $scope.$watch('formData.pets[0].details.petNameCorrect', function(newVal) {
                if (newVal === 'N') {
                    console.log('test scrollToPoint');
                    $timeout(function () {
                        scrollToPoint.scrollTo('mbEditPetModal', 20, 'id');
                    });
                }
            });

            $scope.changePetName = function(pet){               
                if (pet.uri) {
                    pet.details.confirmation = pet.details.confirmation ?  pet.details.confirmation : 'N';
                    pet.details.name = formData.details.newPetName;
                    loadingInterceptor.incrementRequests('Updating Pet name');
                    formService.updatePet(pet).then(function () {
                        if (formData.pets[0].details.petNameCorrect === "N") {
                            formData.pets[0].details.petNameCorrect = "";
                        } else {
                            $scope.tooglePettName();
                        }
                        formData.details.newPetName = "";
                        loadingInterceptor.decrementRequests();
                    }).catch(function (error) {
                        errorHandler.reportErrors(error, 'redirect', 'tech');
                    });
                }
            };
            

        }]);
})(window, window.angular);
